import { Alert, Slide, Snackbar } from "@mui/material";
import { useNotificationContext } from "../../../contexts/NotificationContext";

const TransitionDown = (props: any) => {
  return <Slide {...props} direction="down" />;
};

const NotificationAlert = () => {
  const { notification, setNotification } = useNotificationContext();

  return (
    <Snackbar
      anchorOrigin={{ vertical: "top", horizontal: "center" }}
      open={notification.open}
      autoHideDuration={notification.duration || 1000}
      onClose={() => setNotification({ ...notification, open: false })}
      TransitionComponent={TransitionDown}
    >
      <Alert
        onClose={() => setNotification({ ...notification, open: false })}
        severity={notification?.severity || "success"}
        sx={{ width: "100%" }}
      >
        {notification?.message}
      </Alert>
    </Snackbar>
  );
};

export default NotificationAlert;
